import {Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { Cell } from '../../../lib/data-set/cell';

@Component({
  selector: 'table-cell-view-mode',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div [ngSwitch]="cell.getColumn().type">
        <custom-view-component *ngSwitchCase="'custom'" [cell]="cell"></custom-view-component>
        <div class ="table-col-wi" *ngSwitchCase="'html'" [innerHTML]="cell.getValue()"></div>
        <div class ="table-col-wi"  *ngSwitchDefault>{{ cell.getValue() }}</div>
    </div> 
    `,
})
export class ViewCellComponent {

  @Input() cell: Cell;
}
